import { render, staticRenderFns } from "./NoteThreadChats.vue?vue&type=template&id=a352ba96&"
import script from "./NoteThreadChats.vue?vue&type=script&lang=ts&"
export * from "./NoteThreadChats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports